import { useLocation } from '@solidjs/router';
import { JSX } from 'solid-js';
import { Footer } from '~/components/layouts/Footer';
import { Header } from '~/components/layouts/Header';
import { useStyling } from '~/global-contexts/CompanyStyling';
import BackTop from '../common/back-top/BackTop';

export interface LayoutProps {
  children: JSX.Element;
}

export default function HomeLayout(props: LayoutProps) {
  const { companyStyling } = useStyling();
  const location = useLocation();

  const isRentalApplication = () => location.pathname.includes('/rental-applications');
  const isInsurance = () => location.pathname.includes('/insurance');
  const isSigner = () => location.pathname.includes('/lease-signing');
  const isCompanyNotFound = () => location.pathname.includes('/company-not-found');
  const shouldShowHeaderAndFooter = () => !isRentalApplication() && !isSigner() && !isCompanyNotFound() && !isInsurance();

  return (
    <>
      {shouldShowHeaderAndFooter() ? (
        <div class="flex h-screen w-full flex-col items-center">
          <Header companyStyling={companyStyling?.()} />
          <div class="mt-0 w-full pt-10 md:pt-32">{props.children}</div>
          <Footer companyStyling={companyStyling?.()} />
        </div>
      ) : (
        <>{props.children}</>
      )}
      <BackTop />
    </>
  );
}
